export class RestaurantsRoute {
    static createUrl() {
        return '/restaurants'
    }
}
